export default __webpack_public_path__ + "static/media/completed.47aa939e.gif";